<template>
    <button @click="cancelOffer" class="cancel-offer-button">Cancel Offer</button>
  </template>
  
  <script>
  import { ref } from 'vue';
  import { useStore } from 'vuex';
  
  export default {
    props: {
      purchaseId: {
        type: String,
        required: true
      }
    },
    setup(props) {
      const store = useStore();
      const message = ref('');
  
      const cancelOffer = async () => {
        const userId = store.state.user.id;
        const response = await store.dispatch('offers/cancelOffer', {
          userId,
          purchaseId: props.purchaseId
        });
        message.value = response.message;
      };
  
      return { cancelOffer, message };
    }
  }
  </script>

<style scoped>
/* =========================================================================
   APPLICATION MOBILE (iOS / Android) — préfixé body.is-native, donc inerte
   sur le site web.

   Une annulation est une action destructrice : elle prend le rouge d'alerte
   (--oc-danger) et jamais le rouge de marque, réservé aux actions positives.
   Au repos elle reste discrète (contour), pour ne pas concurrencer l'offre.
   ========================================================================= */

body.is-native .cancel-offer-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: var(--oc-tap);
  margin: var(--oc-sp-3) 0 0;
  padding: 0 var(--oc-sp-5);
  font-family: var(--oc-font-text);
  font-size: var(--oc-text-base);
  font-weight: 700;
  letter-spacing: 0.2px;
  color: var(--oc-danger);
  background: transparent;
  border: 1px solid var(--oc-danger);
  border-radius: var(--oc-r-full);
  box-sizing: border-box;
  cursor: pointer;
  transition: background var(--oc-fast) var(--oc-ease),
              transform var(--oc-fast) var(--oc-ease);
}

body.is-native .cancel-offer-button:active {
  background: var(--oc-danger-bg);
  transform: scale(0.975);
}
</style>
  